import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ChevronRight } from 'lucide-react'

export default function CategoryCard({ name, slug, count, description, icon, gradient = 'bg-gradient-primary' }) {
  return (
    <Link to={`/category/${slug}`}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        whileHover={{ y: -8 }}
        className="card-hover group cursor-pointer"
      >
        <div className="card-body">
          {/* Icon */}
          <motion.div
            whileHover={{ rotate: 6, scale: 1.1 }}
            transition={{ duration: 0.2 }}
            className={`w-16 h-16 ${gradient} rounded-2xl flex items-center justify-center shadow-primary mb-4`}
          >
            <div className="text-white text-2xl">
              {icon}
            </div>
          </motion.div>
          
          {/* Badge */}
          <div className="flex items-start justify-between mb-4">
            <div></div>
            <span className="badge badge-success">
              {count} logos
            </span>
          </div>
          
          {/* Content */}
          <h3 className="heading-3 group-hover:text-nitrr-primary transition-colors">
            {name}
          </h3>
          
          <p className="text-nitrr-text-secondary mb-4 line-clamp-2">
            {description}
          </p>
          
          {/* Action */}
          <div className="flex items-center text-nitrr-primary font-medium group-hover:gap-3 transition-all">
            Explore Collection
            <ChevronRight size={18} className="ml-1 group-hover:translate-x-2 transition-transform" />
          </div>
        </div>

        {/* Hover Effect */}
        <div className="absolute inset-0 bg-gradient-primary opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity duration-300"></div>
      </motion.div>
    </Link>
  )
}
